import DOMPurify from "dompurify";

export const cleanHtml = (dirtyHtml: string) =>
  DOMPurify.sanitize(dirtyHtml, {
    ALLOWED_TAGS: ["img"],
    ALLOWED_ATTR: ["src", "alt", "class"],
  });
